export const CUSTOMER_TYPES = ['commercial', 'domestic', 'block of flats', 'budget'];
